import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import TestimonialsTable from "../../components/testimonials/TestimonialsTable";

const Testimonials = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <TestimonialsTable />
        </WrapperSection>
    );
};

export default Testimonials;
